import {
  //
  DELETE_ASSESSMENT_TEMPLATE,
  DELETE_ASSESSMENT_TEMPLATE_FAILURE,
  DELETE_ASSESSMENT_TEMPLATE_SUCCESS,
  //
  GET_ASSESSMENT_TEMPLATE,
  GET_ASSESSMENT_TEMPLATE_FAILURE,
  GET_ASSESSMENT_TEMPLATE_SUCCESS,
  GET_ASSESSMENT_TEMPLATES,
  GET_ASSESSMENT_TEMPLATES_FAILURE,
  GET_ASSESSMENT_TEMPLATES_SUCCESS,
  //
  SAVE_ASSESSMENT_TEMPLATE,
  SAVE_ASSESSMENT_TEMPLATE_FAILURE,
  SAVE_ASSESSMENT_TEMPLATE_SUCCESS,
  //
  TOGGLE_ASSESSMENT_MODAL,
} from "./constants";

// GET TEMPLATES LIST
export const getAssessmentTemplates = (templateType, payload, onGet) => ({
  type: GET_ASSESSMENT_TEMPLATES,
  templateType,
  payload,
  onGet,
});
export const getAssessmentTemplatesSuccess = (templateType, payload) => ({
  type: GET_ASSESSMENT_TEMPLATES_SUCCESS,
  templateType,
  payload,
});
export const getAssessmentTemplatesFailure = (templateType, payload) => ({
  type: GET_ASSESSMENT_TEMPLATES_FAILURE,
  templateType,
  payload,
});

// GET TEMPLATE
export const getAssessmentTemplate = (templateType, payload, onGet) => ({
  type: GET_ASSESSMENT_TEMPLATE,
  templateType,
  payload,
  onGet,
});
export const getAssessmentTemplateSuccess = (templateType, payload) => ({
  type: GET_ASSESSMENT_TEMPLATE_SUCCESS,
  templateType,
  payload,
});
export const getAssessmentTemplateFailure = (templateType, payload) => ({
  type: GET_ASSESSMENT_TEMPLATE_FAILURE,
  templateType,
  payload,
});

// SAVE TEMPLATE
export const saveAssessmentTemplate = (templateType, payload, onSave) => ({
  type: SAVE_ASSESSMENT_TEMPLATE,
  templateType,
  payload,
  onSave,
});
export const saveAssessmentTemplateSuccess = (templateType, payload) => ({
  type: SAVE_ASSESSMENT_TEMPLATE_SUCCESS,
  templateType,
  payload,
});
export const saveAssessmentTemplateFailure = (templateType, payload) => ({
  type: SAVE_ASSESSMENT_TEMPLATE_FAILURE,
  templateType,
  payload,
});

// DELETE TEMPLATE
export const deleteAssessmentTemplate = (templateType, payload, onDelete) => ({
  type: DELETE_ASSESSMENT_TEMPLATE,
  templateType,
  payload,
  onDelete,
});
export const deleteAssessmentTemplateSuccess = (templateType, payload) => ({
  type: DELETE_ASSESSMENT_TEMPLATE_SUCCESS,
  templateType,
  payload,
});
export const deleteAssessmentTemplateFailure = (templateType, payload) => ({
  type: DELETE_ASSESSMENT_TEMPLATE_FAILURE,
  templateType,
  payload,
});

// TOGGLE MODAL
export const toggleAssessmentModal = (templateType, payload) => ({
  type: TOGGLE_ASSESSMENT_MODAL,
  templateType,
  payload,
});
